export interface IEjendomsoplysning {
    navn: string;
    enhed: string;
    vaerdi: string;
    kommentar: string;
}
